<template>
  <base-material-card
    color="green"
    :title="title"
  >
    <v-form ref="form">
      <v-container class="py-0">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="reseller.name"
              :label="$t('Components.Forms.Reseller.Labels.CompanyName')"
              :rules="[nameValidation]"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="reseller.vatNumber"
              class="purple-input"
              :label="$t('Components.Forms.Reseller.Labels.VatNumber')"
              :rules="[vatNumberValidation]"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="reseller.contactName"
              :label="$t('Components.Forms.Reseller.Labels.ContactName')"
              class="purple-input"
              :rules="[contactNameValidation]"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="reseller.emailAddress"
              :label="$t('Components.Forms.Reseller.Labels.EmailAddress')"
              class="purple-input"
              :rules="[emailAddressValidation]"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="reseller.contactPhone"
              :label="$t('Components.Forms.Reseller.Labels.ContactPhone')"
              class="purple-input"
              :rules="[contactPhoneValidation]"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="reseller.houseNumber"
              :label="$t('Components.Forms.Reseller.Labels.HouseNumber')"
              class="purple-input"
            />
          </v-col>
          <v-col
            cols="12"
            md="10"
          >
            <v-text-field
              v-model="reseller.address"
              :label="$t('Components.Forms.Reseller.Labels.DeliveryAddress')"
              class="purple-input"
              :rules="[addressValidation]"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="reseller.postalCode"
              :label="$t('Components.Forms.Reseller.Labels.DeliveryZip')"
              class="purple-input"
              :rules="[postalCodeValidation]"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="reseller.city"
              :label="$t('Components.Forms.Reseller.Labels.DeliveryCity')"
              class="purple-input"
              :rules="[cityValidation]"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-autocomplete
              v-model="reseller.countryCode"
              color="primary"
              item-color="primary"
              :label="$t('Components.Forms.Reseller.Labels.DeliveryCountry')"
              :items="countries"
              item-text="name"
              item-value="isoCode"
              :rules="[countryCodeValidation]"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="reseller.type"
              :items="companyTypes"
              class="purple-input"
              :label="$t('Components.Forms.Reseller.Labels.CompanyType')"
              :rules="[typeValidation]"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-simple-table class="ml-2">
              <tbody>
                <tr
                  v-for="(item,index) in reseller.vendorIds"
                  :key="index"
                >
                  <td>
                    <debounce-v-btn
                      x-small
                      fab
                      color="error"
                      @click="RemoveVendorIdItem(item)"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </debounce-v-btn>
                  </td>
                  <td>
                    <vendorDropdown
                      v-model="item.vendorId"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.resellerIdentification"
                      :label="$t('Components.Forms.Reseller.Labels.ResellerIdentification')"
                      class="purple-input"
                      :rules="[resellerIdentificationValidation]"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-btn
                      x-small
                      fab
                      color="success"
                      @click="AddVendorIdItem"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <template v-slot:actions>
      <v-row
        no-gutters
        align="center"
      >
        <v-col
          cols="auto"
          class="mr-auto"
        >
          <v-icon
            v-if="showAllResellersLink"
            class="mr-1"
          >
            mdi-menu-left
          </v-icon>
          <router-link
            v-if="showAllResellersLink"
            :to="{ name: 'Resellers', }"
          >
            <span>{{ $t('Components.Forms.Reseller.Links.AllResellers') }}</span>
          </router-link>
        </v-col>
        <v-col cols="auto">
          <debounce-v-btn
            class="font-weight-light"
            color="success"
            @click="Save()"
          >
            {{ $t('General.Buttons.Save') }}
          </debounce-v-btn>
          <debounce-v-btn
            class="font-weight-light"
            color="success"
            @click="Save(true)"
          >
            {{ $t('General.Buttons.SaveClose') }}
          </debounce-v-btn>
          <v-btn
            class="font-weight-light v-btn--tight"
            color="warning"
            @click="$emit('closeResellerForm')"
          >
            {{ $t('General.Buttons.DiscardChanges') }}
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </base-material-card>
</template>

<script>
  import validation from '@/helpers/validationHelper'
  import vendorDropdown from '@/views/dashboard/components/dropdowns/Vendor.vue'

  export default {
    name: 'ResellerForm',
    components: {
      vendorDropdown,
    },
    props: {
      reseller: {
        type: Object,
        required: false,
        default: null,
      },
      showAllResellersLink: {
        type: Boolean,
        required: false,
        default: true,
      },
      badRequestReasons: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data: () => ({ }),
    computed: {
      title () {
        if (!this.reseller.uid) {
          return this.$t('Components.Forms.Reseller.Titles.CreateReseller')
        }
        return this.$t('Components.Forms.Reseller.Titles.ResellerDetails', [this.reseller.name])
      },
      resellers () {
        return this.$store.state.resellers.list
      },
      countries () {
        return this.$store.state.general.countries
      },
      companyTypes () {
        return [this.$t('Components.Forms.Reseller.CompanyTypes.Reseller'), this.$t('Components.Forms.Reseller.CompanyTypes.Agent')]
      },
    },
    created: async function () {
      // check depended store items are ready
      if (this.resellers.length < 1) {
        await this.$store.dispatch('RefreshResellers')
      }
    },
    methods: {
      AddVendorIdItem () {
        this.reseller.vendorIds.push({
          vendorId: '',
          resellerIdentification: '',
        })
      },
      RemoveVendorIdItem (item) {
        var existingElementIndex = this.reseller.vendorIds.findIndex((el, index) => {
          return el.vendorId === item.vendorId && el.resellerIdentification === item.resellerIdentification
        })
        if (existingElementIndex > -1) {
          this.reseller.vendorIds.splice(existingElementIndex, 1)
        }
      },
      async Save (shouldClose) {
        if (this.$refs.form.validate() !== true) {
          return false
        }
        var dispatchEvent = shouldClose ? 'saveAndCloseResellerForm' : 'saveReseller'
        this.$emit(dispatchEvent, this.reseller)
      },
      // Validation function
      emailAddressValidation (value) {
        if (!validation.stringIsNotNullOrWhitespace(value)) {
          return this.$t('Components.Forms.Reseller.Validation.RequiredEmailAddress')
        }
        if (!validation.stringIsEmail(value)) {
          return this.$t('Components.Forms.Reseller.Validation.InvalidEmailAddress')
        }
        if (this.badRequestReasons && this.badRequestReasons.EmailAddress) {
          return this.$t('Components.Forms.Reseller.Validation.BadRequestReasons.' + this.badRequestReasons.EmailAddress[0])
        }
        return true
      },
      nameValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.NameRequired')
      },
      vatNumberValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.VatNumberRequired')
      },
      addressValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.AddressRequired')
      },
      postalCodeValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.ZipRequired')
      },
      cityValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.CityRequired')
      },
      countryCodeValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.CountryCodeRequired')
      },
      typeValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.ResellerTypeRequired')
      },
      resellerIdentificationValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.IdentificationRequired')
      },
      contactNameValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.ContactNameRequired')
      },
      contactPhoneValidation (value) {
        return validation.stringIsNotNullOrWhitespace(value) || this.$t('Components.Forms.Reseller.Validation.ContactPhoneRequired')
      },
    },
  }
</script>
